module.exports = __webpack_public_path__ + "static/media/car-cancel-mobile.ef1fa7f2.svg";